/**
 * ImTopbarButton — chat icon + unread badge to mount in pro topbars.
 */
import React, { useState } from "react";
import { MessageSquare } from "lucide-react";
import { useIm } from "./ImProvider";
import InstantMessagingDrawer from "./InstantMessagingDrawer";

export default function ImTopbarButton({ className = "" }) {
  const [open, setOpen] = useState(false);
  const im = useIm();
  const unread = im.totalUnread;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid="im-topbar-button"
        className={`btn-ghost relative px-3 py-2 rounded-full text-[12px] font-medium inline-flex items-center gap-1.5 ${className}`}
      >
        <MessageSquare size={13} />
        <span className="hidden sm:inline">Messages</span>
        {unread > 0 && (
          <span
            data-testid="im-topbar-badge"
            className="absolute -top-1 -right-1 text-[10px] font-semibold px-1.5 py-0.5 rounded-full bg-[var(--mc-mint)] text-[var(--mc-navy-950)] min-w-[18px] text-center leading-tight"
          >
            {unread > 99 ? "99+" : unread}
          </span>
        )}
      </button>
      <InstantMessagingDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
